export default __webpack_public_path__ + "img/fNbASgce.cb4861a2.svg";